<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Work Orders to Check Out"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Check out work orders."
      @on-submit="createCheckOutWorkOrdersImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Work Orders to Check Out Template.xlsx"
              :file-provider="$importsAPI.getCheckOutWorkOrdersTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'CheckOutWorkOrdersImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'check-out-work-orders-imports-add-modal',
    };
  },
  methods: {
    createCheckOutWorkOrdersImport(data, handleCreate) {
      handleCreate(this.$importsAPI.checkOutWorkOrdersCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
